<template>
  <Table
    ref="table"
    :layers-filters="layersFilters"
    @setLayerFeaturesFilters="setLayerFeaturesFilters"
    @deleteLayerFeaturesFilters="deleteLayerFeaturesFilters"
    :is-custom-layer="true"
    :custom-layer-data="customLayerData"
    :statuses-items="statusesItems"
    :init-sorting="initSorting"
  >
    <template v-slot:additionalTools="scope">
      <v-col style="flex-grow: 0" v-for="(select, idx) of selects" :key="idx">
        <table-select v-model="scope.filters.navbar_filter[select.name]" v-bind="select" @input="changeFilters()" />
      </v-col>
    </template>
  </Table>
</template>

<script>
import TableSelect from '@/components/TableSelect.vue';

import { get, sync } from 'vuex-pathify';
import Table from '@/components/Table.vue';

export default {
  name: 'TableZdmFailures',
  components: {
    Table,
    TableSelect,
  },
  data: vm => ({
    selects: [
      {
        name: 'ZgloszenieStatus',
        itemText: 'value',
        label: vm.$i18n.t('dialog.status'),
        items: [],
      },
    ],
    statusesItems: [
      {
        key: 'przyjete',
        color: 'rgba(0,145,234)',
        shadowColor: 'rgba(0,145,234,0.2)',
      },
      {
        key: 'potwierdzone',
        color: 'rgba(24,128,56)',
        shadowColor: 'rgba(24,128,56,0.2)',
      },
      {
        key: 'przekazane',
        color: 'rgba(255,136,0)',
        shadowColor: 'rgba(255,136,0,0.2)',
      },
    ],
  }),
  computed: {
    activeTool: sync('tools/activeTool'),
    failuresLayerId: get('admin/modulesMapping@zdm_failures.layer_id'),
    layersFilters: get('layers/layersFilters'),
    statuses: get('admin/modulesMapping@zdm_failures.statuses'),
    createDateAttributeName: get('admin/modulesMapping@zdm_failures.create_date_attribute_name'),
    customLayerData() {
      return {
        routeName: 'zdm_failure',
        eventName: 'toggleZDMFailures',
        filterEventName: 'toggleZDMFailuresFilter',
        layerId: this.failuresLayerId,
      };
    },
    initSorting() {
      return [
        {
          attribute: this.createDateAttributeName,
          sort: 'desc',
        },
      ];
    },
  },
  methods: {
    changeFilters() {
      this.$refs.table.handleFilter();
    },
    deleteLayerFeaturesFilters(currentLayerId) {
      this.$store.set('layers/DELETE_LAYERS_FILTERS!', currentLayerId);
    },
    setLayerFeaturesFilters(filter) {
      this.$store.set('layers/SET_LAYERS_FILTERS!', filter);
    },
    onLayerChanged() {
      this.$refs.table.onLayerChanged();
    },
    setFilters(additionalTableFilterValues, isInit) {
      setTimeout(() => {
        this.$refs.table.setNavbarFilters(additionalTableFilterValues, isInit);
      });
    },
    async init() {
      const additionalTableFilterValues = this.$route.params.additionalTableFilterValues;
      if (additionalTableFilterValues) {
        this.setFilters(additionalTableFilterValues, true);
      }
    },
  },
  beforeCreate() {
    this.$once('hook:beforeDestroy', () => {
      this.$nextTick(() => {
        this.activeTool = undefined;
      });
      this.$root.$emit('toggleZDMFailures', false);
    });
  },
  created() {
    this.init();
    this.$root.$off('setAdditionalTableFilterValues');
    this.$root.$on('setAdditionalTableFilterValues', this.setFilters);
  },
  beforeMount() {
    this.selects.find(select => select.name === 'ZgloszenieStatus').items = this.statusesItems.map(item => {
      item.value = this.statuses[item.key];
      return item;
    });
  },
};
</script>
